import { Popover, Button, DatePicker } from "antd";
import { useContext, useEffect, useState } from "react";
import moment, { Moment } from "moment";
import { AuthContext } from "../../../../context/AuthContext";
import { fetchDataAuto } from "../../../../services/auto";
import { ExportToExcel } from "../../../../utils/exportExcel";
import { RiFileExcel2Line } from "react-icons/ri";

const { RangePicker } = DatePicker;

const ExportContent = (props: any) => {
  const { token, expire } = useContext(AuthContext);
  const [isLoading, setLoading] = useState<boolean>(false);
  const { hide } = props;
  const dateFormat = "DD/MM/YYYY";
  const timeFormat = "HH:mm";
  const today: Moment = moment().add(0, "day");

  const [filterDate, setFilterDate] = useState<any>([today, today]);

  const handleFetchBookings = async () => {
    setLoading(true);
    const uri = `api/proforma/export/data?startDate=${moment(
      new Date(filterDate[0])
    ).format("YYYYMMDD")}&endDate=${moment(new Date(filterDate[1])).format(
      "YYYYMMDD"
    )}&all=0`;

    const data = await fetchDataAuto({ uri, token, expire });

    const getYear = (date: any) => {
      let year = new Date(date).getFullYear();
      return year;
    };

    const getTotal = (proforma: any) => {
      let total = 0;
      if (proforma?.vehicles) {
        proforma.vehicles.forEach((vehicle: any) => {
          total = total + vehicle?.prices?.inclusive / 1.18;
        });
      }
      return total;
    };

    const getProformaTotals: any = (proforma: any) => {
      let discount = 0;
      let vat = 0;
      const total = getTotal(proforma);
      if (proforma?.discount?.isPercentage) {
        discount = total * proforma?.discount?.value;
      } else {
        discount = proforma?.discount?.value;
      }
      vat = (total - discount) * proforma?.vat?.amount;

      const exchange = proforma?.source?.exchange;

      const unit = total - discount;

      const net = unit + vat;
      const res = net * exchange;

      return res;
    };

    ExportToExcel(
      data?.map((item: any) => ({
        "PFI Date": moment(item?.createdAt).format(
          `${dateFormat} ${timeFormat}`
        ),
        "PFI Ref": `${
          item?.source?.name === "OFF-LEASE" ? "SFL/SSBCL" : "KJL/AUTOMARK"
        }/${item?.pfi}/${getYear(item?.createdAt)}`,
        Customer: item?.contact?.name,
        Mobile: item?.contact?.mobile,
        Email: item?.contact?.email,
        Model: item?.vehicles[0]?.model?.name,
        Year: item?.vehicles[0]?.year,
        Color: item?.vehicles[0]?.color,
        Chassis: item?.vehicles[0]?.chassis,
        Registration: item?.vehicles[0]?.registration,
        "Sales Consultant": item?.creator?.name,
        Status: item?.status?.state,
        Value: getProformaTotals(item),
      })),
      `Proforma from ${moment(filterDate[0]).format(dateFormat)} to ${moment(
        filterDate[1]
      ).format(dateFormat)}.xlsx`
    );
    hide();
    setLoading(false);
  };

  useEffect(() => {}, [filterDate]);

  return (
    <div>
      <RangePicker
        format={dateFormat}
        onChange={(date: any) => {
          setFilterDate(date);
        }}
      />

      <div className="flex flex-row justify-between mt-2">
        <Button
          type="primary"
          onClick={() => {
            handleFetchBookings();
          }}
          danger
          className="bg-automark-pale hover:bg-automark-dark"
        >
          {isLoading ? "Exporting ... " : "Export"}
        </Button>

        <Button onClick={hide}>Cancel</Button>
      </div>
    </div>
  );
};

const ExportProforma = (props: any) => {
  const [isVisible, toggleVisibility] = useState(false);

  const hide = () => {
    toggleVisibility(false);
  };

  const show = () => {
    toggleVisibility(true);
  };

  return (
    <Popover
      content={<ExportContent {...props} hide={hide} />}
      title="Select Date To Export"
      trigger="hover"
      open={isVisible}
    >
      <button
        className="border rounded-md px-2 py-1 flex items-center mx-2"
        onClick={show}
      >
        <RiFileExcel2Line size={20} />
        <span className="mx-1">Export </span>
      </button>
    </Popover>
  );
};

export default ExportProforma;
